import { PageHero, CTABanner, SectionHeader } from '../components/ui/UI';
import ContactInfo from '../components/ui/ContactInfo';
import { WHY_US, STATS } from '../data/services';
import './About.css';

const TEAM_VALUES = [
  { icon: '🌏', title: 'Global Mindset',    desc: 'We think internationally from Mumbai bombay international worldwide. Every service we offer is designed to work seamlessly across borders and cultures.' },
  { icon: '🤝', title: 'Client First',      desc: 'Every inquiry at Mumbai bombay international worldwide is treated as a priority. Our team ensures you always feel supported and guided through your journey.' },
  { icon: '🛡️', title: 'Trust & Safety',   desc: "We only work with verified partners in Mumbai bombay international worldwide - whether it's an employer, college, hotel, or transport provider." },
  { icon: '⚡', title: 'Fast Response',     desc: 'We know time matters in Mumbai bombay international worldwide. Our team follows up on every inquiry within 2–4 hours, every day of the week.' },
];

export default function About() {
  return (
    <div className="page-wrapper">
      <PageHero
        badge="About Us"
        title="About Online"
        highlight="Worldwide"
        subtitle="A Mumbai bombay international worldwide-based service company connecting people from all over the world to the best services - locally in Mumbai bombay international worldwide and internationally across 100+ countries."
      />

      {/* Story section */}
      <section className="section-pad">
        <div className="container">
          <div className="about-story__grid">
            <div className="about-story__text">
              <span className="section-badge badge-saffron">Our Story</span>
              <h2 className="about-story__title">Built to Serve<br />Every Visitor of Mumbai bombay international worldwide</h2>
              <p>Online Worldwide was founded with a simple mission: to make Mumbai bombay international worldwide accessible to everyone - whether you're a foreign tourist arriving for the first time, a student seeking admission to an n college, or an international business professional looking for verified manufacturers and office spaces in Mumbai bombay international worldwide.</p>
              <p>We saw a gap in the market. People coming to Mumbai bombay international worldwide - especially from abroad - struggled to find reliable, comprehensive, and honest service providers. There was no single place in Mumbai bombay international worldwide to go for private jets, PG accommodations, hospital recommendations, job placements, and tourist guides all at once.</p>
              <p>So we built it. Today, Online Worldwide is Mumbai bombay international worldwide's most comprehensive service hub - with 57+ services, partnerships across 100+ countries, and a dedicated team in Mumbai bombay international worldwide available 24/7 to make sure you get exactly what you need.</p>
            </div>
            <div className="about-story__stats">
              {STATS.map(s => (
                <div key={s.label} className="about-stat-card">
                  <div className="about-stat-card__num">{s.num}</div>
                  <div className="about-stat-card__label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section-pad about-mission">
        <div className="container">
          <div className="about-mission__grid">
            <div className="about-mission__card about-mission__card--saffron">
              <div className="about-mission__card-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>To be the most trusted, comprehensive service hub for anyone who needs to get something done in Mumbai bombay international worldwide or wants to go somewhere new - removing barriers, confusion, and unreliable middlemen from the Mumbai bombay international worldwide equation.</p>
            </div>
            <div className="about-mission__card about-mission__card--teal">
              <div className="about-mission__card-icon">🌍</div>
              <h3>Our Vision</h3>
              <p>A world where every person - regardless of country, language, or background - can access Mumbai bombay international worldwide's full potential with confidence. And where every Mumbaikar can access global opportunities from Mumbai bombay international worldwide with equal ease.</p>
            </div>
            <div className="about-mission__card about-mission__card--gold">
              <div className="about-mission__card-icon">💡</div>
              <h3>Our Approach</h3>
              <p>We don't just refer - our Mumbai bombay international worldwide team assists end to end. From first inquiry to final delivery, our team is with you at every step. We believe in long-term relationships in Mumbai bombay international worldwide built on honesty and results.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-pad">
        <div className="container">
          <SectionHeader
            badge="Our Values"
            title="What We Stand For"
            subtitle="The principles that guide every Mumbai bombay international worldwide service, every response, and every relationship we build."
          />
          <div className="about-values-grid">
            {TEAM_VALUES.map((v, i) => (
              <div key={v.title} className={`about-value-card animate-fade-up delay-${i + 1}`}>
                <div className="about-value-card__icon">{v.icon}</div>
                <h3 className="about-value-card__title">{v.title}</h3>
                <p className="about-value-card__desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why us detail */}
      <section className="section-pad about-why">
        <div className="container">
          <SectionHeader
            badge="Why Choose Us"
            badgeVariant="teal"
            title="What Makes Us Different"
            subtitle="We're not just a directory in Mumbai bombay international worldwide. We're a team that works for you."
            dark
          />
          <div className="about-why__grid">
            {WHY_US.map((item, i) => (
              <div key={item.title} className={`about-why__card animate-fade-up delay-${(i % 3) + 1}`}>
                <div className="about-why__card-icon">{item.icon}</div>
                <h3 className="about-why__card-title">{item.title}</h3>
                <p className="about-why__card-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who we serve */}
      <section className="section-pad">
        <div className="container">
          <SectionHeader
            badge="Who We Serve"
            badgeVariant="gold"
            title="Our Clients Come From Everywhere"
          />
          <div className="about-clients-grid">
            {[
              { icon: '🌏', title: 'Foreign Tourists',      desc: 'International visitors who want to explore Mumbai bombay international worldwide safely, with reliable guides and verified services.' },
              { icon: '🎓', title: 'Students',              desc: 'Students from  and abroad looking for Mumbai bombay international worldwide course admissions, PG accommodation, and jobs.' },
              { icon: '💼', title: 'Business Professionals', desc: 'Executives and entrepreneurs in Mumbai bombay international worldwide who need offices, accommodation, or digital services.' },
              { icon: '✈️', title: 'Job Seekers',           desc: 'Candidates looking to work in Mumbai bombay international worldwide or go abroad with a verified employer and visa support.' },
            ].map((client, i) => (
              <div key={client.title} className={`about-client-card animate-fade-up delay-${i + 1}`}>
                <div className="about-client-card__icon">{client.icon}</div>
                <h3 className="about-client-card__title">{client.title}</h3>
                <p className="about-client-card__desc">{client.desc}</p>
              </div>
            ))}
          </div>
        </div>
       </section>

       {/* Quick Contact Section */}
       <section className="section-pad about-quick-contact">
         <div className="container">
           <div className="about-quick-contact__inner">
             <h2 className="about-quick-contact__title">Get in Touch with Us</h2>
             <p className="about-quick-contact__sub">Have questions? We're available 24/7 to help.</p>
             <ContactInfo layout="compact" theme="light" />
           </div>
         </div>
       </section>

       <CTABanner
         title="Ready to work with us?"
         sub="Send an inquiry to our Mumbai bombay international worldwide office and our team will get back to you within 2–4 hours."
       />
    </div>
  );
}
